<template lang="pug">
  .social-tags
    a.social-tag(
      v-for="(tag, index) in tags"
      :href="tag.link"
      target="_blank"
      rel="noopener"
      title="Open in new tab")
      i.bx.bx-6(:class="[tag.icon]")
</template>

<script>
import { mapSocialNetworks } from '~/utilities/normalizers'

export default {
  name: 'SocialTag',
  props: {
    socialNetworks: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      tags: []
    }
  },

  created () {
    this.tags = mapSocialNetworks(this.socialNetworks)
      .filter(e => e.username)
      .map(e => ({ ...e, link: `${e.prefix}${e.username}` }))
  }
}
</script>

<style lang="scss" scoped>
.social-tags {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  .social-tag {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
